import {Component, OnInit, ViewChild} from '@angular/core';
import {LeftpanelComponent, PromoteToEnvironmentComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {EndpointComponent, GithubConnectionComponent} from '../manage-entities/manage-entities.component';
import {MatDialog} from '@angular/material';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {AccountInfoService} from '../user/account-info.service';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-cognitive-search',
    templateUrl: './cognitive-search.component.html',
    styleUrls: ['./cognitive-search.component.scss']
})
export class CognitiveSearchComponent implements OnInit {

    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    partnerKey = localStorage.getItem('partnerKey');
    totalNumberOfPlans = 0;
    countOfEnterPriseSearchPlans = 0;
    countPartnerPlans: any = 0;
    maxCount: any = 10;
    itemList = [];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    filterData: any[];
    searchText: string;
    searchText1: string;
    gatewayUrl: any;
    DeleteEntityCheck = true;
    item = [];
    columns = ['Plan Name', 'Version', 'Category', 'Description', 'Created At', 'Last Updated', 'Status'];
    entityMappingToSort = ['entityname', 'version', '', '', '', 'creationTime', 'lastModifiedTime', '', ''];
    componentLoading = true;
    resultLoading = false;
    resultPanelOpened = false;
    mode = new FormControl('over');
    plans: any;
    selectedPlan: any;
    searchResult: any;
    // @ViewChild('aceEditor') editor:any;

    constructor(public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private confPost: ConfService,
                public dialog: MatDialog,
                public router: Router) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getEnterpriseSearchLists();
    }

    async getEnterpriseSearchLists() {
        this.componentLoading = true;
        const payload = {
            'partner': this.partner,
            'account': this.account,
        };
        this.confPost.getEnterprisePlans(payload).subscribe(data => {
            const res: any = data;
            if (res) {
                this.plans = res;
                this.componentLoading = false;
            }

        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving plans.');
            this.componentLoading = false;
            this.router.navigateByUrl('/controlplane');
        });

    }

    runPlan(item) {
        this.selectedPlan = item;
    }

    editPlan(item) {

    }

    deletePlan(item) {

    }

    promoteAPI(item) {
        this.dialog.open(PromoteToEnvironmentComponent, {
            height: '40%',
            width: '30%',
            data: {partner: this.partner, account: this.account, entity: item.entityname, version: item.version, type: 'ENTERPRISESEARCH'}
        });
    }

    openGitHubDialog(partner, account, entityname, version, type) {
        const dialogRef = this.dialog.open(GithubConnectionComponent, {
            minWidth: '30vw',
            data: {
                partner: partner,
                account: account,
                entityname: entityname,
                version: version,
                type: type
            }
        });
    }


    openDialog(partner, account, entity, version): void {
        const data = {};
        data['partner'] = partner;
        data['account'] = account;
        data['entity'] = entity;
        data['version'] = version;
        data['url'] = this.gatewayUrl;
        data['partnerKey'] = this.partnerKey;
        data['type'] = 'entity';
        const dialogRef = this.dialog.open(EndpointComponent, {
            width: '80%',
            height: '80%',
            data: data,
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    getCreatedDate(val) {
        // const data = val.split('#');
        // if (Number(data[2]) !== 0) {
        //     return new Date(Number(data[2])).toLocaleString();
        // } else {
        //     return new Date(Date.now() - Number(this.getTotalUptime(val)) * 1000 * 60 * 60).toLocaleString();
        // }

        if (val) {
            return this.platform.timeConverter(val);
        } else {
            return '';
        }

    }

    getLastModifiedData(val, val1) {
        if (val) {
            return this.platform.timeConverter(val);
        } else {
            if (val1) {
                return this.platform.timeConverter(val1);
            } else {
                return '';
            }
        }
    }

    getVersion(val) {
        if (val) {
            /* var str = Object.values(val).toString();
         return str.substr(str.indexOf('.') + 1, str.length);*/
            const data = val.split('#');
            return data[1];
        }
    }

    refreshBillingForPartnerAccount() {
        this.confPost.refreshBillingForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            this.platform.openSnackBar('Refreshed the duration of API Availability for this account successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while refreshing the duration of API Availability', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

    searchTextResult() {
        if (this.searchText1 && this.searchText1 !== '') {
            const payload = {
                searchForText: 'Laravel Login authentication issue with different named table',
                projectName: 'apiplatform-384909',
                location: 'us-central1',
                indexEndpoint: '2797654560317898752',
                indexId: 'sampleSearchIndex',
                model: 'textembedding-gecko@001',
                numberOfNeighbors: '5'
            };
            this.resultLoading = true;
            this.confPost.searchText(payload).subscribe(data => {
                this.resultLoading = false;
                // console.log(data);
                this.searchResult = data;
                // this.editor.value = data;

            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while searching text. Please try again later');
                this.resultLoading = false;

            });

        } else {
            this.platform.handleErrorGracefully('', 'Please enter text to search');
        }
    }

    stringifyJson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

}
